import React from 'react';
import {ButtonDropdown} from './ButtonDropdown';
import {Choice} from '../types';

type EntryAdminActionsProps = {
    isActive: boolean;
    options: Choice[];
    onSelect: (action: string, choice?: Choice) => void;
};

export const EntryAdminActions: React.FunctionComponent<EntryAdminActionsProps> = ({
                                                                                       isActive = false,
                                                                                       options = [],
                                                                                       onSelect,
                                                                                   }): JSX.Element => {
    return (
        <div className="container" id="admin-actions-container">
            <div className="row">
                <div className="col-12">
                    <ButtonDropdown
                        label="Admin Actions"
                        isActive={isActive}
                        options={options}
                        onSelect={onSelect}
                    />
                </div>
            </div>
        </div>
    );
}